interface StatusDotProps {
  status: 'online' | 'offline' | 'late' | 'ON_TIME' | 'LATE' | 'NO_SHOW';
  className?: string;
}

export function StatusDot({ status, className = '' }: StatusDotProps) {
  // Map attendance statuses to display statuses
  const statusMap: Record<string, string> = {
    'ON_TIME': 'online',
    'LATE': 'late',
    'NO_SHOW': 'offline',
    'online': 'online',
    'offline': 'offline',
    'late': 'late'
  };
  
  const mappedStatus = statusMap[status] || 'offline';
  const statusClass = `status-${mappedStatus}`;
  
  return <span className={`status-dot ${statusClass} ${className}`} />;
}
